/** Marcador de URL para redirecionar ao primeiro ponto após carregar o roteiro. */
export const ROTEIRO_PONTO_INICIO = 'inicio';

/**
 * @param {string|object|undefined|null} state
 * @returns {string}
 */
function getPontoStateValue(state) {
    if (!state) return '';
    if (typeof state === 'string') return state;
    if (typeof state === 'object' && state.value != null) {
        return String(state.value);
    }
    return '';
}

/**
 * @param {string|object|undefined|null} state
 * @returns {boolean}
 */
export function isPontoPendente(state) {
    const value = getPontoStateValue(state);
    return !value || value === 'PENDING';
}

/**
 * @param {{ points?: Array<{ state?: string|object }> }|null|undefined} roteiro
 * @returns {boolean}
 */
export function hasPontoPendente(roteiro) {
    return (roteiro?.points ?? []).some((ponto) => isPontoPendente(ponto.state));
}

/**
 * @param {{ points?: Array<{ id: number }> }|null|undefined} roteiro
 * @returns {number|null}
 */
export function getFirstPontoId(roteiro) {
    const first = roteiro?.points?.[0];
    return first?.id ?? null;
}

/**
 * @param {{ points?: Array<{ id: number }> }|null|undefined} roteiro
 * @param {string|number} pontoId
 * @returns {object|null}
 */
export function getPontoById(roteiro, pontoId) {
    if (!roteiro?.points) return null;
    const numericId = Number(pontoId);
    if (!Number.isFinite(numericId)) return null;
    return roteiro.points.find((p) => p.id === numericId) || null;
}

/**
 * @param {{ points?: Array<{ id: number }> }|null|undefined} roteiro
 * @param {string|number} currentPontoId
 * @param {'prev'|'next'} direction
 * @returns {number|null}
 */
export function getAdjacentPontoId(roteiro, currentPontoId, direction) {
    if (!roteiro?.points?.length) return null;
    const index = roteiro.points.findIndex((p) => p.id === Number(currentPontoId));
    if (index < 0) return null;
    const nextIndex = direction === 'prev' ? index - 1 : index + 1;
    const adjacent = roteiro.points[nextIndex];
    return adjacent?.id ?? null;
}

/**
 * @param {string|number|undefined|null} pontoId
 * @returns {boolean}
 */
export function isPontoInicioMarker(pontoId) {
    return String(pontoId ?? '').trim().toLowerCase() === ROTEIRO_PONTO_INICIO;
}
